export const baseURL = "https://ferrywheel.lapinchat.com/";
export const adminBaseURL = "https://admin.lapinchat.com/";
export const key = "6qu6o5c$&2j(ngp6vhh&ut_%jczuc2cyy-2rzi-pv3h&sq&6i!";